import React from "react";
import { CommentNode } from "./types";
import {
  formatCommentTime,
  getActivityGroup,
  getCommentDisplayExcerpt,
  getCommentDisplayText,
  getCommentScopeClass,
  getCommentScopeLabel,
} from "./commentText";
import { getRootForComment } from "./commentTreeModel";

interface CommentRecentViewProps {
  comments: CommentNode[];
  byId: Map<number, CommentNode>;
  selectedCommentId: number | null;
  currentEditId?: number | null;
  onSelect: (commentId: number) => void;
  onOpenReader: (commentId: number) => void;
}

const groupOrder: Array<"Today" | "Yesterday" | "Older"> = ["Today", "Yesterday", "Older"];

const CommentRecentView: React.FC<CommentRecentViewProps> = ({
  comments,
  byId,
  selectedCommentId,
  currentEditId,
  onSelect,
  onOpenReader,
}) => {
  const groups = comments.reduce<Record<"Today" | "Yesterday" | "Older", CommentNode[]>>(
    (acc, comment) => {
      acc[getActivityGroup(comment.createdAt)].push(comment);
      return acc;
    },
    { Today: [], Yesterday: [], Older: [] }
  );

  return (
    <div className="comment-explorer-recent-view">
      {groupOrder.map((group) => {
        const items = groups[group];
        if (items.length === 0) return null;

        return (
          <section key={group} className="comment-explorer-activity-group">
            <h3>{group}</h3>
            {items.map((comment) => {
              const root = getRootForComment(byId, comment);
              const scopeClass = getCommentScopeClass(comment, currentEditId);
              return (
                <article
                  key={comment.id}
                  className={`comment-explorer-activity-card ${comment.id === selectedCommentId ? "is-selected" : ""}`}
                >
                  <button type="button" className="comment-explorer-activity-main" onClick={() => onSelect(comment.id)}>
                    <span className={`comment-explorer-scope-dot ${scopeClass}`} />
                    <div>
                      <strong>{comment.user?.name || "Unknown user"} · {formatCommentTime(comment.createdAt)}</strong>
                      <p>{comment.id === selectedCommentId ? getCommentDisplayText(comment) : getCommentDisplayExcerpt(comment, 155)}</p>
                      {root && root.id !== comment.id && (
                        <em>in thread: {getCommentDisplayExcerpt(root, 60)}</em>
                      )}
                    </div>
                  </button>
                  <div className="comment-explorer-activity-actions">
                    <span>{getCommentScopeLabel(comment, currentEditId)}</span>
                    <button type="button" onClick={() => onOpenReader(comment.id)}>
                      Open
                    </button>
                  </div>
                </article>
              );
            })}
          </section>
        );
      })}
    </div>
  );
};

export default CommentRecentView;
